module.exports = __webpack_public_path__ + "static/media/coffee_logo.1a358a24.jpg";